import React, { useState } from 'react';
import HeaderPanel from './HeaderPanel';
import DashboardSummary from './DashboardSummaryNew';

const QueueEfficiency = (props) => {
    return (
        <div className="top-margin dashboard execution-performance">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <DashboardSummary title="Queue Efficiency summary" />
            </div>
        </div>
    );
};

export default QueueEfficiency;
